import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React from "react";
import HttpClient from "../../lib/HttpClient";
import { useSnackbarContext } from "../../contexts/Snackbar";

interface ConfirmDeleteReportDailogInterface {
  reportId: string;
  onReportDeletedFn: () => void;
  onDailogCanceledFn: () => void;
}

const ConfirmDeleteReportDialog = ({
  reportId,
  onReportDeletedFn,
  onDailogCanceledFn,
}: ConfirmDeleteReportDailogInterface) => {
  const { setSnackbar } = useSnackbarContext();

  function deleteReport(reportId: string) {
    HttpClient.performPut<any>(`/api/v1/users/reports/${reportId}`)
      .then(({ body }) => {
        if (body) {
          console.log(body);
          if (body.status.success) {
            setSnackbar({
              message: "Report deleted",
              severity: "success",
            });
            onReportDeletedFn();
          } else {
            setSnackbar({
              message: body?.status?.message ?? "Unable to delete report",
              severity: "error",
            });
          }
        } else {
          setSnackbar({
            message: body?.status?.message ?? "Report not found",
            severity: "error",
          });
        }
      })
      .catch((e) => {
        setSnackbar({
          message: e.body?.status?.message,
          severity: "error",
        });
      });
  }

  return (
    <Dialog
      open={true}
      onClose={() => onDailogCanceledFn()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete file"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure to delete this file
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onDailogCanceledFn()}>No</Button>
        <Button
          onClick={() => {
            deleteReport(reportId);
          }}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteReportDialog;
